const countryLabels = {
    AF: {id: 'country.AF', defaultMessage: 'Afghanistan'},
    AR: {id: 'country.AR', defaultMessage: 'Argentina'},
    AU: {id: 'country.AU', defaultMessage: 'Australia'},
    AT: {id: 'country.AT', defaultMessage: 'Austria'},
    BH: {id: 'country.BH', defaultMessage: 'Bahrain'},
    BE: {id: 'country.BE', defaultMessage: 'Belgium'},
    BG: {id: 'country.BG', defaultMessage: 'Bulgaria'},
    CA: {id: 'country.CA', defaultMessage: 'Canada'},
    CL: {id: 'country.CL', defaultMessage: 'Chile'},
    CN: {id: 'country.CN', defaultMessage: 'China'},
    CZ: {id: 'country.CZ', defaultMessage: 'Czech Republic'},
    DK: {id: 'country.DK', defaultMessage: 'Denmark'},
    EE: {id: 'country.EE', defaultMessage: 'Estonia'},
    FI: {id: 'country.FI', defaultMessage: 'Finland'},
    FR: {id: 'country.FR', defaultMessage: 'France'},
    DE: {id: 'country.DE', defaultMessage: 'Germany'},
    GR: {id: 'country.GR', defaultMessage: 'Greece'},
    HK: {id: 'country.HK', defaultMessage: 'Hong Kong, China'},
    HU: {id: 'country.HU', defaultMessage: 'Hungary'},
    IN: {id: 'country.IN', defaultMessage: 'India'},
    IE: {id: 'country.IE', defaultMessage: 'Ireland'},
    IL: {id: 'country.IL', defaultMessage: 'Israel'},
    IT: {id: 'country.IT', defaultMessage: 'Italia'},
    JP: {id: 'country.JP', defaultMessage: 'Japan'},
    KZ: {id: 'country.KZ', defaultMessage: 'Kazakhstan'},
    KR: {id: 'country.KR', defaultMessage: 'South Korea'},
    KW: {id: 'country.KW', defaultMessage: 'Kuwait'},
    LV: {id: 'country.LV', defaultMessage: 'Latvia'},
    LI: {id: 'country.LI', defaultMessage: 'Liechtenstein'},
    LT: {id: 'country.LT', defaultMessage: 'Lithuania'},
    LU: {id: 'country.LU', defaultMessage: 'Luxembourg'},
    MO: {id: 'country.MO', defaultMessage: 'Macau, China'},
    MY: {id: 'country.MY', defaultMessage: 'Malaysia'},
    MC: {id: 'country.MC', defaultMessage: 'Monaco'},
    NL: {id: 'country.NL', defaultMessage: 'Netherlands'},
    NZ: {id: 'country.NZ', defaultMessage: 'New Zealand'},
    NO: {id: 'country.NO', defaultMessage: 'Norway'},
    OM: {id: 'country.OM', defaultMessage: 'Oman'},
    PL: {id: 'country.PL', defaultMessage: 'Poland'},
    PT: {id: 'country.PT', defaultMessage: 'Portugal'},
    QA: {id: 'country.QA', defaultMessage: 'Qatar'},
    RO: {id: 'country.RO', defaultMessage: 'Romania'},
    RU: {id: 'country.RU', defaultMessage: 'Russia'},
    SA: {id: 'country.SA', defaultMessage: 'Saudi Arabia'},
    SG: {id: 'country.SG', defaultMessage: 'Singapore'},
    SK: {id: 'country.SK', defaultMessage: 'Slovakia'},
    SI: {id: 'country.SI', defaultMessage: 'Slovenia'},
    ZA: {id: 'country.ZA', defaultMessage: 'South Africa'},
    ES: {id: 'country.ES', defaultMessage: 'Spain'},
    SE: {id: 'country.SE', defaultMessage: 'Sweden'},
    CH: {id: 'country.CH', defaultMessage: 'Switzerland'},
    TW: {id: 'country.TW', defaultMessage: 'Taiwan, China'},
    TH: {id: 'country.TH', defaultMessage: 'Thailand'},
    TN: {id: 'country.TN', defaultMessage: 'Tunisia'},
    TR: {id: 'country.TR', defaultMessage: 'Turkey'},
    UA: {id: 'country.UA', defaultMessage: 'Ukraine'},
    AE: {id: 'country.AE', defaultMessage: 'United Arab Emirates'},
    GB: {id: 'country.GB', defaultMessage: 'United Kingdom'},
    US: {id: 'country.US', defaultMessage: 'United States'},
    AZ: {id: 'country.AZ', defaultMessage: 'Azerbaijan'},
    BR: {id: 'country.BR', defaultMessage: 'Brazil'},
    VN: {id: 'country.VN', defaultMessage: 'Vietnam'},
    MX: {id: 'country.MX', defaultMessage: 'Mexico'},
    AL: {id: 'country.AL', defaultMessage: 'Albania'},
    AD: {id: 'country.AD', defaultMessage: 'Andorra'},
    AM: {id: 'country.AM', defaultMessage: 'Armenia'},
    BY: {id: 'country.BY', defaultMessage: 'Belarus'},
    BM: {id: 'country.BM', defaultMessage: 'Bermuda'},
    BA: {id: 'country.BA', defaultMessage: 'Bosnia and Herzegovina'},
    KH: {id: 'country.KH', defaultMessage: 'Cambodia'},
    CO: {id: 'country.CO', defaultMessage: 'Colombia'},
    HR: {id: 'country.HR', defaultMessage: 'Croatia'},
    CY: {id: 'country.CY', defaultMessage: 'Cyprus'},
    GE: {id: 'country.GE', defaultMessage: 'Georgia'},
    GI: {id: 'country.GI', defaultMessage: 'Gibraltar'},
    GL: {id: 'country.GL', defaultMessage: 'Greenland'},
    GD: {id: 'country.GD', defaultMessage: 'Grenada'},
    GP: {id: 'country.GP', defaultMessage: 'Guadeloupe'},
    GG: {id: 'country.GG', defaultMessage: 'Guernsey, C.I.'},
    IS: {id: 'country.IS', defaultMessage: 'Iceland'},
    ID: {id: 'country.ID', defaultMessage: 'Indonesia'},
    IQ: {id: 'country.IQ', defaultMessage: 'Iraq'},
    JE: {id: 'country.JE', defaultMessage: 'Jersey, C.I.'},
    JO: {id: 'country.JO', defaultMessage: 'Jordan'},
    KG: {id: 'country.KG', defaultMessage: 'Kyrgyzstan'},
    LB: {id: 'country.LB', defaultMessage: 'Lebanon'},
    MT: {id: 'country.MT', defaultMessage: 'Malta'},
    MQ: {id: 'country.MQ', defaultMessage: 'Martinique'},
    MN: {id: 'country.MN', defaultMessage: 'Mongolia'},
    ME: {id: 'country.ME', defaultMessage: 'Montenegro'},
    PE: {id: 'country.PE', defaultMessage: 'Peru'},
    PH: {id: 'country.PH', defaultMessage: 'Philippines'},
    PR: {id: 'country.PR', defaultMessage: 'Puerto Rico'},
    MK: {id: 'country.MK', defaultMessage: 'North Macedonia'},
    RE: {id: 'country.RE', defaultMessage: 'La Réunion'},
    SM: {id: 'country.SM', defaultMessage: 'San Marino'},
    RS: {id: 'country.RS', defaultMessage: 'Serbia'},
    UY: {id: 'country.UY', defaultMessage: 'Uruguay'},
    UZ: {id: 'country.UZ', defaultMessage: 'Uzbekistan'},
    AS: {id: 'country.AS', defaultMessage: 'American Samoa'},
    AO: {id: 'country.AO', defaultMessage: 'Angola'},
    AI: {id: 'country.AI', defaultMessage: 'Anguilla'},
    AW: {id: 'country.AW', defaultMessage: 'Aruba'},
    BS: {id: 'country.BS', defaultMessage: 'Bahamas'},
    BB: {id: 'country.BB', defaultMessage: 'Barbados'},
    FK: {id: 'country.FK', defaultMessage: 'Falkland Islands (Malvinas)'},
    FO: {id: 'country.FO', defaultMessage: 'Faroe Islands'},
    IM: {id: 'country.IM', defaultMessage: 'Isle of Man'},
    BL: {id: 'country.BL', defaultMessage: 'Saint Barthèlemy'},
    AX: {id: 'country.AX', defaultMessage: 'Åland Islands'},
    TF: {id: 'country.TF', defaultMessage: 'French Southern Territories'},
    SX: {id: 'country.SX', defaultMessage: 'Sint Maarten'},
    ST: {id: 'country.ST', defaultMessage: 'São Tomé and Príncipe'},
    SC: {id: 'country.SC', defaultMessage: 'Seychelles'},
    SJ: {id: 'country.SJ', defaultMessage: 'Svalbard and Jan Mayen'},
    WS: {id: 'country.WS', defaultMessage: 'Samoa'},
    VI: {id: 'country.VI', defaultMessage: 'Virgin Islands, U.S.'},
    PW: {id: 'country.PW', defaultMessage: 'Palau'},
    PA: {id: 'country.PA', defaultMessage: 'Panama'},
    PG: {id: 'country.PG', defaultMessage: 'Papua New Guinea'},
    PY: {id: 'country.PY', defaultMessage: 'Paraguay'},
    HT: {id: 'country.HT', defaultMessage: 'Haiti'},
    DM: {id: 'country.DM', defaultMessage: 'Dominica'},
    EG: {id: 'country.EG', defaultMessage: 'Egypt'},
    FJ: {id: 'country.FJ', defaultMessage: 'Fiji'},
    GU: {id: 'country.GU', defaultMessage: 'Guam'},
    NC: {id: 'country.NC', defaultMessage: 'New Caledonia'},
    NU: {id: 'country.NU', defaultMessage: 'Niue'},
    MS: {id: 'country.MS', defaultMessage: 'Montserrat'},
    MU: {id: 'country.MU', defaultMessage: 'Mauritius'},
    MV: {id: 'country.MV', defaultMessage: 'Maldives'},
    KE: {id: 'country.KE', defaultMessage: 'Kenya'},
    KI: {id: 'country.KI', defaultMessage: 'Kiribati'},
    TM: {id: 'country.TM', defaultMessage: 'Turkmenistan'},
    JM: {id: 'country.JM', defaultMessage: 'Jamaica'},
    VG: {id: 'country.VG', defaultMessage: 'Virgin Islands'},
    VE: {id: 'country.VE', defaultMessage: 'Venezuela'},
    YT: {id: 'country.YT', defaultMessage: 'Mayotte'},
    NP: {id: 'country.NP', defaultMessage: 'Nepal'},
    NG: {id: 'country.NG', defaultMessage: 'Nigeria'},
    SL: {id: 'country.SL', defaultMessage: 'Sierra Leone'},
    SB: {id: 'country.SB', defaultMessage: 'Solomon Islands'},
    TO: {id: 'country.TO', defaultMessage: 'Tonga'},
    TT: {id: 'country.TT', defaultMessage: 'Trinidad and Tobago'},
}

export {countryLabels}
